module.exports = __webpack_public_path__ + "media/images/global/icons/music-1dfa49c3f5980cb44ec914e82a676322.svg";